module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "基础物料",
      "name": "first"
    }
  }, [_c('service', {
    attrs: {
      "get-status": _vm.service
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "商品",
      "name": "second"
    }
  }, [_c('goods', {
    ref: "goods",
    attrs: {
      "get-status": _vm.goods
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f635f37", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f635f37"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/service/index.vue
// module id = 2588
// module chunks = 0